"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDeliveryTime = void 0;
//#region Base types
var ProductDeliveryTime;
(function (ProductDeliveryTime) {
    ProductDeliveryTime["SAME_DAY"] = "same_day";
    ProductDeliveryTime["NEXT_DAY"] = "next_day";
    ProductDeliveryTime["HOURS_48"] = "48_hours";
    ProductDeliveryTime["DAYS_3_5"] = "3_5_days";
    ProductDeliveryTime["DAYS_5_UP"] = "5_up_days";
    ProductDeliveryTime["PICK_UP"] = "pick_up";
})(ProductDeliveryTime = exports.ProductDeliveryTime || (exports.ProductDeliveryTime = {}));
